var _g, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "120px",
    height: "120px",
    viewBox: "0 0 120 120",
    enableBackground: "new 0 0 120 120",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icomoon-ignore"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "#FFFFFF",
    stroke: "#449FDB",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 0
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M47.572,118.916c0.324,0.271,0.428,0.916,0.428,1V104H30.996L47.572,118.916z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M96,44H24v8h4v48h19.9c1.38,0,4.1,1.116,4.1,2.5V120h38.9c1.379,0,1.1-1.116,1.1-2.5V52h4V44z M74.4,80h-30 c-1.384,0-2.5-0.616-2.5-2s1.116-2,2.5-2h30c1.384,0,2.5,0.616,2.5,2S75.779,80,74.4,80z M74.4,68h-30c-1.384,0-2.5-0.616-2.5-2 s1.116-2,2.5-2h30c1.384,0,2.5,0.616,2.5,2S75.779,68,74.4,68z M74.4,92h-30c-1.384,0-2.5-0.616-2.5-2s1.116-2,2.5-2h30 c1.384,0,2.5,0.616,2.5,2S75.779,92,74.4,92z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M111.9,32H6.9C5.516,32,4,34.616,4,36v41.5C4,78.884,5.516,80,6.9,80H24V56h-2.1c-1.384,0-1.9-2.116-1.9-3.5 v-10c0-1.384,0.516-2.5,1.9-2.5h75c1.379,0,3.1,1.116,3.1,2.5v10c0,1.384-1.721,3.5-3.1,3.5H96v24h15.9c1.379,0,4.1-1.116,4.1-2.5 V36C116,34.616,113.279,32,111.9,32z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M96,2.5C96,1.116,93.279,0,91.9,0h-65C25.516,0,24,1.116,24,2.5V24h72V2.5z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.34ca5df257dad82b87fd1e00f1ab1b9a.svg";
export { ForwardRef as ReactComponent };